const resetPickedRecipe = () => {
    return {
        type: 'RESET_PICKED_RECIPE'
    }
};

export { resetPickedRecipe };